/**
 * STYLING: Plain Tailwind ONLY!
 * Generic toggle-switch used in TextToolSettings.
 */

interface Props {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  hint?: string;
  badge?: string;
}

export function ToggleSwitch({ checked, onChange, label, hint, badge }: Props) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className="flex items-center gap-2 cursor-pointer"
    >
      <span className={`relative inline-flex w-9 h-5 rounded-full transition-colors flex-shrink-0 ${
        checked ? 'bg-primary-600' : 'bg-neutral-300 dark:bg-neutral-600'
      }`}>
        <span className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow-sm transition-transform ${
          checked ? 'translate-x-4' : 'translate-x-0'
        }`} />
      </span>
      <span className="text-sm text-neutral-700 dark:text-neutral-300">{label}</span>
      {hint && <span className="text-xs text-neutral-400">{hint}</span>}
      {badge && (
        <span className="text-2xs px-1.5 py-0.5 rounded-md bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 font-medium">
          {badge}
        </span>
      )}
    </button>
  );
}
